// extracted by mini-css-extract-plugin
export const root = "faq-list-module--root--2LicE";